export default __webpack_public_path__ + "static/media/MyWork.35e2ac7d.svg";